import getLocationDropdownResultData from './getLocationDropdownResultData';
import FindLocationResultState from '../data/schema/FindLocationResultState';

export default function shiftFindResultsHighlightIndex(
    disableUseThisLocation: boolean,
    isIncrement: boolean,
    findLocationResultState: FindLocationResultState
): number {
    let resultData = getLocationDropdownResultData(disableUseThisLocation, findLocationResultState);

    let findResultCount = resultData.findResultsCount + resultData.findResultOffset;
    let position: number;

    if (isIncrement) {
        position = findLocationResultState.findResultHightlightIndex + 1;
    } else {
        position = findLocationResultState.findResultHightlightIndex - 1;
    }

    return (position + findResultCount) % findResultCount;
}
